import { render, staticRenderFns } from "./AddExCertificationModal.vue?vue&type=template&id=590ef17e&"
import script from "./AddExCertificationModal.vue?vue&type=script&lang=js&"
export * from "./AddExCertificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports